module.exports = __webpack_public_path__ + "static/media/doors.f6642a71.svg";